import { Interpolation, Theme } from "@mui/material"

const style: Interpolation<Theme> = {
  body: {
    margin: 0
  },
  '*': {
    border: "0 solid #fff"
  },
  'a': {
    cursor: "pointer !important",
  },
  '#main-content': {
    marginTop: "120px",
    maxWidth: "1200px",
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: "16px",
    paddingRight: "16px",
  },
  '.welcome': {
    position: "relative",
    h2: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      // fontSize: "2.25rem",
      paddingLeft: "4rem",
      paddingRight: "4rem",
      textAlign: "center",
      position: "absolute",
      backgroundColor: "#fff",
      opacity: "0.75",
      paddingTop: "1rem",
      paddingBottom: "1rem",
      fontWeight: "900",
      fontSize: "2.25rem",
      "@media (max-width:992px)": {
        fontSize: "1rem",
        paddingLeft: "1rem",
        paddingRight: "1rem",
      }
    },
    img: {
      maxWidth: "100%",
      width: "100%",
      height: "auto",
      opacity: "0.5"
    }
  },
  h2: {
    textAlign: "center",
    fontWeight: 900
  },
  ".post-content": {
    // 記事コンテンツの中におけるマークダウンのスタイル
    table: {
      width: "100%",
      thead: {
        backgroundColor: "#303F9F",
        color: "#fff",
        borderBottom: "1px solid #00695C",
        tr: {
          lineHeight: "38px"
        },
        th: {
          paddingLeft: "0.5rem",
          paddingRight: "0.5rem"
        },
        "th, td": {
          border: "1px solid #333"
        }
      },
      tbody: {
        tr: {
          lineHeight: "38px",
          td: {
            borderBottom: "1px solid #333"
          }
        }
      }
    }
  },
  aside: {
    ".MuiListSubheader-root": {
      marginBottom: "2px",
      lineHeight: "24px",
      fontWeight: 900,
    },
    ".MuiListItemIcon-root": {
      width: "32px",
      minWidth: "32px"
    }
  },
  section: {
    marginBottom: "60px"
  },
  "hr.MuiDivider-root": {
    marginTop: "24px",
  },
  '.blog-article': {
    lineHeight: "1.8em",
    'h2': {
      borderLeft: "6px double #000",
      fontSize: "1.6rem",
      padding: "0.5rem 1rem",
      marginBottom: "0.5rem",
      marginTop: "2rem",
      textAlign: "left"
    },
    'h3': {
      marginBottom: "0.5rem",
      marginTop: "2rem",
      paddingLeft: "1rem",
      paddingBottom: "0.5rem",
      borderBottom: "3px solid rgb(204, 228, 255)",
      position: "relative",
      "&::after": {
        position: "absolute",
        content: "' '",
        display: "block",
        borderBottom: "3px solid rgb(84, 114, 205)",
        bottom: "-3px",
        width: "20%"
      }
    },
    blockquote: {
      position: "relative",
      fontStyle: "italic",
      color: "rgb(135, 149, 161)",
      backgroundColor: "rgb(241, 245, 248)",
      marginBottom: "1rem",
      padding: "1rem 2.5rem",
      border: "1px solid #8bc0b8",
      borderRadius: "10px",
      margin: "0",
      "&::before": {
        content: "'\"'",
        display: "inline-block",
        position: "absolute",
        color: "rgb(96, 111, 123)",
        fontSize: "2.5rem",
        top: "0px",
        left: "0px",
        paddingLeft: "1rem",
        paddingTop: "1.5rem",
        backgroundImage: "none",
        width: "64px",
        height: "64px"
      },
      "&::after": {
        backgroundImage: "none",
        right: "10px",
        bottom: "10px",
        width: "64px",
        height: "64px",
        color: "#8bc0b8"
      }
    }
  },
  '.btn-sns': {
    color: "white",
    display: "flex",
    alignItems: "stretch",
    width: "100%",
    textDecoration: "none",
    '.sns-logo': {
      width: "36px",
      padding: "8px",
      maxWidth: "100%",
      height: "auto"
    },
    span: {
      flexGrow: 1,
      alignSelf: "center",
      paddingLeft: "12px"
    }
  },
  ".service-page-item": {
    "h3": {
      fontSize: "1.5rem",
      borderTop: "4px solid #22292f",
      textAlign: "left",
      fontWeight: "bold",
      paddingTop: "0.75rem",
      paddingLeft: "1.25rem",
      borderBottom: "4px solid #22292f",
      marginBottom: "1rem",
      paddingBottom: "0.75rem"
    },
    ".delivery-flow-timeline li:before": {
      flex: 0.2
    },
    ".problem": {
      "ul": {
        lineHeight: "1.8em",
        paddingTop: "0.25em",
        paddingBottom: "0.25em",
        fontSize: "1.25rem"
      },
      ".point": {
        color: "rgb(96, 111, 123)",
        fontSize: "1rem",
        borderRadius: "0.5rem",
        borderColor: "#6cb2eb",
        borderWidth: "2px",
        "p.strong": {
          textAlign: "center",
          color: "white",
          fontWeight: "bold",
          backgroundColor: "#6cb2eb",
          lineHeight: "1.8em",
          paddingTop: "0.5rem",
          paddingBottom: "0.5rem",
          margin: 0,
          fontSize: "1.25rem",
        },
        ".content": {
          fontSize: "1.125rem",
          textAlign: "left",
          padding: "1rem"
        }
      }
    }
  },
  ".MuiTypography-body1": {
    lineHeight: "1.8em !important",
    paddingTop: "4px",
    paddingBottom: "4px"
  },
  ".book-item": {
    display: "flex",
    backgroundColor: "#eff8ff",
    padding: "32px",
    ".book-content": {
      display: "flex",
      flexDirection: "column",
      paddingLeft: "16px",
    },
    "@media (max-width:992px)": {
      padding: "4px",
      ".MuiCardMedia-media": {
        width: "120px"
      }
    }
  },
  ".news-item": {
    boxShadow: 3,
    marginBottom: "16px",
    ".MuiCardActionArea-root": {
      display: "flex",
      padding: "8px",
      width: "100%",
      ".MuiCardMedia-root": {
        flexBasis: "240px",
      },
      "h3": {
        fontWeight: 900,
        fontSize: "1.2em",
        marginBottom: "8px"
      }
    },
    "@media (max-width:992px)": {
      ".MuiCardActionArea-root": {
        ".MuiCardMedia-root": {
          flexBasis: "120px",
        },
        ".MuiCardContent-root": {
          padding: "8px"
        },
        "h3": {
          fontWeight: 600,
          fontSize: "1em"
        }
      }
    }
  },
  ".service-item": {
    backgroundColor: "#F5F5F5 !important",
    ".MuiCardMedia-root": {
      padding: "16px",
      img: {
        width: "100%",
      }
    },
    ".MuiCardContent-root": {
      h4: {
        fontWeight: 900,
        fontSize: "1.6em",
        marginTop: "16px",
        marginBottom: "32px",
      }
    },
    "@media (max-width:992px)": {
      ".MuiCardMedia-root": {
        padding: "4px",
      },
      ".MuiCardContent-root": {
        h4: {
          fontWeight: "600 !important",
          fontSize: "1em !important",
          marginTop: "8px",
          marginBottom: "16px"
        },
        ".MuiTypography-body2": {
          display: "none"
        }
      }
  }
  },
  ".input-ipaddress": {
    "input#parts1, input#parts2, input#parts3, input#parts4": {
      textAlign: "center",
    }
  },
  ".iptools-output-table": {
    ".MuiDataGrid-row:has(.check-ok), .MuiDataGrid-row:has(.check-ok):hover": {
      backgroundColor: "blue",
      color: "white"
    },
    ".MuiDataGrid-row:has(.check-ng), .MuiDataGrid-row:has(.check-ng):hover": {
      backgroundColor: "red",
      color: "white"
    }
  }
}
export default style